<template>
  <div id="app">
    <router-view />
    <div class="icon-policy">
      <el-popover placement="top-start" popper-class="policy-popper" ref="policyPopover" :visible-arrow="false" width="410" trigger="manual">
        <div class="content">
          <h3 class="cookie-banner-title">{{ $t("控制您的隐私") }}</h3>
          <div class="cookie-banner-content">{{ $t("我们的网站使用cookie来改善导航。") }}</div>
          <div class="cookie-banner-title">
            <span @click="toLink('information/avisodeprivacidad')" class="underline-link">{{ $t("隐私政策") }}</span>
            <span class="cookie-banner-divisor">-</span>
            <span @click="toLinkPdf" class="underline-link">{{ $t("Cookie政策") }}</span>
            <span class="cookie-banner-divisor">-</span>
            <span @click="toLink('information/termsAndAgreement')" class="underline-link">{{ $t("使用条款") }}</span>
          </div>
          <div style="text-align: right; margin-top: 22px">
            <el-button size="mini" class="cookie-banner-btn reject" type="text" @click="handleReject">{{ $t("拒绝") }}</el-button>
            <el-button type="primary" class="cookie-banner-btn sure" size="mini" @click="handleSure">{{ $t("接受") }}</el-button>
          </div>
        </div>
        <template slot="reference">
          <div class="policy-icon" @click="toPolicy">
            <img src="@/assets/imgs/policy.png" style="width: 44px; padding: 10px" />
          </div>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    const policy = localStorage.getItem("cookiePolicy");
    if (policy !== "true") {
      // 等 Vue 渲染完再打开弹窗
      this.$nextTick(() => {
        this.$refs.policyPopover.doShow();
      });
    }
  },
  methods: {
    toPolicy() {
      this.$refs.policyPopover.doShow();
    },
    toLink(url) {
      const fullUrl = window.location.origin + "/" + url;
      window.open(fullUrl, "_blank");
    },
    toLinkPdf() {
      const fullUrl = "https://cms.jtexpress.com/overseas/jmsbr/brazil/01JP63N3PHAKPAE1TT3VBG5A9R.pdf";
      window.open(fullUrl, "_blank");
    },
    handleReject() {
      localStorage.setItem("cookiePolicy", "false");
      this.$refs.policyPopover.doClose();
    },
    handleSure() {
      localStorage.setItem("cookiePolicy", "true");
      this.$refs.policyPopover.doClose();
    },
  },
};
</script>

<style>
@import "./assets/css/reset.css";
#app {
  width: 100%;
}
.policy-icon {
  background: #e60000;
  border-radius: 50%;
  width: 44px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.icon-policy {
  width: 40px;
  position: fixed;
  left: 30px;
  bottom: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  cursor: pointer;
}
.policy-popper {
  border-radius: 20px !important;
  left: 75px !important;
  .content {
    background: white;
    padding: 10px;
  }
  .cookie-banner-title {
    font-weight: 700;
    font-size: 12px;
    color: #e60000;
  }
  .underline-link {
    cursor: pointer;
    color: #e60000;
    text-decoration: none;
    border-bottom: 1px solid #e60000;
  }
  .cookie-banner-divisor {
    margin: 0 3px;
  }
  .cookie-banner-content {
    line-height: 36px;
    height: 36px;
    font-size: 12px;
  }
  .cookie-banner-btn {
    padding: 10px 30px;
    border-radius: 20px;
    font-weight: 600;
  }
  .reject,
  .reject:hover {
    color: #34464c;
    border: 1px solid #34464c;
  }
  .sure {
    margin-left: 40px !important;
  }
}
</style>
